







































































































import Vue from "vue";
export default Vue.extend({
  name: "conf-info",
  props: ["dialog", "info"],
});
